<template>
  <div class="ArticleProductTile">
    <span class="block uppercase t-h5 mb-xs">{{ title }}</span>
    <ProductData :products="[product]">
      <template #default="{ products }">
        <ArticleTileProductCard
          :products="products"
        />
      </template>
    </ProductData>
  </div>
</template>

<script>
export default {
  name: 'ArticleProductTile',

  props: {
    title: {
      type: String,
      required: true,
    },

    product: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="postcss">
.ArticleProductTile .ProductCard,
.ArticleProductTile .ProductCard__product {
  @apply mb-0;
}
</style>
